// =======================================
// DATA TYPES
// =======================================

/**
 * Client data structure
 */
export interface ClientOption {
  id: number | string;
  company_name: string;
}

/**
 * Props interface for SearchableClientDropdown
 */
export interface SearchableClientDropdownProps {
  /** Currently selected client ID */
  value?: string | number | null;
  /** Callback when client selection changes */
  onChange: (clientId: string | number | null, client?: ClientOption | null) => void;
  /** Placeholder text for the input */
  placeholder?: string;
  /** Additional CSS classes */
  className?: string;
  /** Whether the dropdown is disabled */
  disabled?: boolean;
  /** Whether to show a "No Client" option */
  allowNone?: boolean;
  /** Custom label for the "No Client" option */
  noneLabel?: string;
  /** Whether the field is required */
  required?: boolean;
  /** Whether to show loading state */
  showLoading?: boolean;
}

/**
 * Search response from the backend
 */
export interface ClientSearchResponse {
  clients: ClientOption[];
  total_count: number;
  has_more: boolean;
}

// =======================================
// CONSTANTS AND OPTIONS
// =======================================

/**
 * Minimum characters required to trigger search
 */
export const MIN_SEARCH_LENGTH = 3;

/**
 * Debounce delay for search input in milliseconds
 */
export const SEARCH_DEBOUNCE_DELAY = 300;

/**
 * Maximum number of clients to fetch per search
 */
export const MAX_SEARCH_RESULTS = 50;

/**
 * Default placeholder text
 */
export const DEFAULT_PLACEHOLDER = "Search clients...";

/**
 * Default "No Client" option
 */
export const NO_CLIENT_OPTION = {
  id: 'none',
  company_name: 'No Client',
  label: 'No Client',
  value: 'none'
} as const; 